import { createSlice } from "@reduxjs/toolkit";

const linkedinProfilesSlice = createSlice({
  name: "linkedinProfiles",
  initialState: {
    status: "idle",
    error: null,
    loading: false,
    linkedin_profiles_list: [],
    filteredProfiles: [],
    // Filter state
    filters: {
      searchTerm: '',
      selectedJDs: [],
      selectedClients: [],
      activeOnly: true,
      dateRange: [null, null]
    },
    // Statistics
    statistics: {
      total_profiles: 0,
      active_profiles: 0,
      inactive_profiles: 0,
      recent_profiles: 0,
      monthly_stats: []
    }
  },
  reducers: {
    setError: (state, action) => {
      state.error = action.payload;
      state.status = "failed";
    },    
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    loadLinkedInProfilesData(state, action) {
      console.log("loadLinkedInProfilesData " + JSON.stringify(action.payload));
      state.linkedin_profiles_list = action.payload;
      // Reset filtered profiles to show all profiles when new data is loaded
      state.filteredProfiles = action.payload;
    },
    setFilteredProfiles: (state, action) => {
      state.filteredProfiles = action.payload;
    },
    setStatistics: (state, action) => {
      state.statistics = action.payload;
    },
    // Filter state reducers
    setSearchTerm: (state, action) => {
      state.filters.searchTerm = action.payload;
    },
    setSelectedJDs: (state, action) => {
      state.filters.selectedJDs = Array.isArray(action.payload) ? action.payload : [];
    },
    setSelectedClients: (state, action) => {
      state.filters.selectedClients = Array.isArray(action.payload) ? action.payload : [];
    },
    setActiveOnly: (state, action) => {
      state.filters.activeOnly = action.payload;
    },
    setDateRange: (state, action) => {
      state.filters.dateRange = action.payload;
    },
    clearAllFilters: (state) => {
      state.filters = {
        searchTerm: '',
        selectedJDs: [],
        selectedClients: [],
        activeOnly: true,
        dateRange: [null, null]
      };
      // Reset filtered profiles to show all profiles when filters are cleared
      state.filteredProfiles = state.linkedin_profiles_list;
    },
  },
});

export const {
  setError,
  setLoading,
  loadLinkedInProfilesData,
  setFilteredProfiles,
  setStatistics,
  // Filter actions
  setSearchTerm,
  setSelectedJDs,
  setSelectedClients,
  setActiveOnly,
  setDateRange,
  clearAllFilters
} = linkedinProfilesSlice.actions;

// Selectors
export const selectLinkedInProfiles = (state) => state.linkedinProfiles.linkedin_profiles_list;
export const selectFilteredProfiles = (state) => state.linkedinProfiles.filteredProfiles;
export const selectLoading = (state) => state.linkedinProfiles.loading;
export const selectStatistics = (state) => state.linkedinProfiles.statistics;

// Filter selectors
export const selectFilters = (state) => state.linkedinProfiles.filters;
export const selectSearchTerm = (state) => state.linkedinProfiles.filters.searchTerm;
export const selectSelectedJDs = (state) => state.linkedinProfiles.filters.selectedJDs || [];
export const selectSelectedClients = (state) => state.linkedinProfiles.filters.selectedClients || [];
export const selectActiveOnly = (state) => state.linkedinProfiles.filters.activeOnly;
export const selectDateRange = (state) => state.linkedinProfiles.filters.dateRange;

export default linkedinProfilesSlice.reducer;
